import { cn } from '@/utils/cn';

interface AppShellProps {
  children: React.ReactNode;
  className?: string;
}

export function AppShell({ children, className }: AppShellProps) {
  return (
    <div className={cn('md-shell', className)}>
      {children}
    </div>
  );
}
